<form id="confirmForm">
  <dialog-header>{{ title }}</dialog-header>
  <mat-dialog-content>
    <p class="align-left" [innerHTML]="message"></p>
  </mat-dialog-content>
  <mat-dialog-actions
    align="end"
    class="tw-gap-2.5"
    [class.has-secondary-action]="!!secondaryButton"
  >
    <button
      rv-button
      variant="secondary"
      id="cancelButton"
      type="button"
      class="confirm-modal-action"
      [class.confirm-modal-action--full]="!secondaryButton"
      [class.confirm-modal-action--fit]="!!secondaryButton"
      (click)="close()"
    >
      {{ cancelButton }}
    </button>
    @if (secondaryButton) {
      <button
        rv-button
        variant="secondary"
        id="confirm-secondary"
        type="button"
        class="confirm-modal-action confirm-modal-action--fit"
        (click)="selectSecondary()"
      >
        {{ secondaryButton }}
      </button>
    }
    @if (confirmButtonClass === 'warn') {
      <button
        mat-flat-button
        type="button"
        color="warn"
        id="confirm-primary"
        class="confirm-modal-action"
        [class.confirm-modal-action--full]="!secondaryButton"
        [class.confirm-modal-action--fit]="!!secondaryButton"
        (click)="confirm()"
      >
        <span>{{ confirmButton }}</span>
      </button>
    } @else {
      <button
        rv-button
        type="button"
        id="confirm-primary"
        class="confirm-modal-action"
        [class.confirm-modal-action--full]="!secondaryButton"
        [class.confirm-modal-action--fit]="!!secondaryButton"
        (click)="confirm()"
      >
        <span>{{ confirmButton }}</span>
      </button>
    }
  </mat-dialog-actions>
</form>
